import React from 'react';
import {
  Container,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from '@mui/material';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import GitHubIcon from '@mui/icons-material/GitHub';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './Projects.scss';

const Projects = () => {
  const projects = [
    {
      title: 'Tip of The Tongue',
      organization: 'Binghamton University',
      description: 'Generated result sequences for general queries related to movies, drama\'s, sports\'s etc using Retrieval augmented generation. Built with Python and RAG pipelines leveraging OpenAI and Claude for natural language understanding.',
      technologies: ['Python', 'RAG', 'NLP', 'OpenAI', 'Claude'],
      githubUrl: 'https://github.com/avsujit',
      liveUrl: null,
    },
    {
      title: 'Social Media Platforms Toxicity Analyzer',
      organization: 'Binghamton University',
      description: 'Designed a front-end dashboard that plotted toxicity trends using Angular and Python Flask APIs, powered by a custom data crawler for social media content analysis and visualization.',
      technologies: ['Angular', 'Python Flask', 'Data Visualization', 'Web Scraping'],
      githubUrl: 'https://github.com/avsujit',
      liveUrl: null,
    },
  ];

  return (
    <section id="projects" className="projects-section">
      <Container maxWidth="lg">
        <Typography variant="h2" className="section-title" gutterBottom>
          Projects
        </Typography>
        <Box className="section-divider" />
        <Box className="projects-accordion-list">
          {projects.map((project, index) => (
            <Accordion key={index} className="project-accordion" defaultExpanded={false}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                className="project-summary"
              >
                <FolderOutlinedIcon className="project-icon" />
                <Box className="project-summary-content">
                  <Typography variant="subtitle1" className="project-title">
                    {project.title}
                  </Typography>
                  <Typography variant="caption" className="project-organization">
                    {project.organization}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails className="project-details">
                <Typography variant="body2" className="project-description">
                  {project.description}
                </Typography>
                <Box className="project-technologies">
                  {project.technologies.map((tech, idx) => (
                    <Box key={idx} className="tech-tag">
                      {tech}
                    </Box>
                  ))}
                </Box>
                <Box className="project-links">
                  {project.githubUrl && (
                    <Button
                      component="a"
                      href={project.githubUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="small"
                      startIcon={<GitHubIcon />}
                      className="project-link-btn"
                    >
                      Code
                    </Button>
                  )}
                  {project.liveUrl && (
                    <Button
                      component="a"
                      href={project.liveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="small"
                      startIcon={<OpenInNewIcon />}
                      className="project-link-btn"
                    >
                      Live Demo
                    </Button>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </section>
  );
};

export default Projects;
